/**
 * Authentification token for Unryo Connect.
 */
interface UnryoToken {
  id: string,
  key: string,
  token: string,
  expiration?: number
  type?: string,
  secret?: string
  user: string
  namespace?: string
  tooltip?: boolean
  status?: UnryoTokenStatus
  unryoTokenExpiration?: UnryoTokenExpiration
}

/**
 * UnryoToken status to present as a message.
 */
interface UnryoTokenStatus {
  text?: string
  warn?: boolean
}

/**
 * UnryoToken expiration data.
 */
interface UnryoTokenExpiration {
  date: string
  text: string
  warn?: boolean
}

/**
 * UnryoToken type scope.
 */
export enum TokenType {
  NODE = 'node',
  SECRET = 'secret'
}

/**
 * UnryoToken user scope.
 */
export enum TokenUser {
  NODE = 'node',
  VAULT = 'vault'
}

export const tokenFindRules = {
  node: (t: UnryoToken) => t.expiration === undefined && (t.type === undefined || t.type === TokenType.NODE),
  vault: (t: UnryoToken) => t.id === TokenUser.VAULT && t.type === TokenType.SECRET
}

export const tokenBodies = {
  node: {
    value: {
      type: TokenType.NODE
    }
  },
  vault: {
    value: {
      id: TokenUser.VAULT,
      type: TokenType.SECRET
    }
  }
}
